import type { EventDetail } from "@cdt/shared";

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { formatDateTimeLong } from "@/lib/formatters";

interface EventExtractedFieldsProps {
  event: EventDetail;
}

interface FieldRow {
  label: string;
  value: React.ReactNode;
  wide?: boolean;
}

function NullValue() {
  return <span className="text-muted-foreground">-</span>;
}

function textOrNull(value: string | null): React.ReactNode {
  if (!value || value.trim().length === 0) return <NullValue />;
  return value;
}

export function EventExtractedFields({ event }: EventExtractedFieldsProps) {
  const rows: FieldRow[] = [
    { label: "Titolo", value: textOrNull(event.title), wide: true },
    {
      label: "Descrizione",
      value: event.description ? (
        <span className="whitespace-pre-wrap">{event.description}</span>
      ) : (
        <NullValue />
      ),
      wide: true,
    },
    {
      label: "Inizio",
      value: event.startDate ? formatDateTimeLong(event.startDate) : <NullValue />,
    },
    {
      label: "Fine",
      value: event.endDate ? formatDateTimeLong(event.endDate) : <NullValue />,
    },
    { label: "Luogo", value: textOrNull(event.location) },
    { label: "Organizzatore", value: textOrNull(event.organizer) },
    { label: "Tipologia", value: textOrNull(event.eventType) },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Dati evento estratti</CardTitle>
      </CardHeader>
      <CardContent>
        <dl className="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
          {rows.map((row) => (
            <div
              key={row.label}
              className={row.wide ? "md:col-span-2" : undefined}
            >
              <dt className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
                {row.label}
              </dt>
              <dd className="mt-1 text-sm">{row.value}</dd>
            </div>
          ))}
        </dl>
      </CardContent>
    </Card>
  );
}
